<app-admin-nav-details
pageName="Reported Bugs"
pageMessage="View all the reported bugs"
>
  <button class="btn btn-toggle" (click)="toggleView()">
    Switch to {{ viewMode === "card" ? "Table View" : "Card View" }}
  </button>
</app-admin-nav-details>

<!-- 🃏 Card View -->
<div *ngIf="viewMode === 'card'" class="card-container">
  <div class="bug-card" *ngFor="let bug of bugs">
    <div class="card-content">
      <div class="badges-container mb-3">
        <span
          class="badge priority-badge"
          [ngClass]="getPriorityClass(bug.priority)"
          *ngIf="bug.priority">
          {{ bug.priority }}
        </span>
        <span
          class="badge status-badge"
          [ngClass]="getStatusClass(bug.status || 'open')">
          {{ bug.status }}
        </span>
      </div>
      <h6 class="card-title mb-2 text-black">{{ bug.title }}</h6>
      <div class="card-info">
        <p><strong>Date:</strong> {{ bug.createdAt | date: "yyyy-MM-dd" }}</p>
      </div>
      <button class="btn btn-view" (click)="viewBug(bug)">View Bug</button>
    </div>
  </div>
</div>

<!-- 📋 Table View -->
<div *ngIf="viewMode === 'table'" class="table-container">
  <div class="table-responsive">
    <table class="custom-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Title</th>
          <th>App Name</th>
          <th>Priority</th>
          <th>Status</th>
          <th>Date</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let bug of bugs; let i = index">
          <td class="text-black">{{(pageNumber - 1) * pageSize + i + 1 }}</td>
          <td class="text-black">{{bug.title}}</td>
          <td class="text-black">{{bug.appName}}</td>
          <td>
            <span
              class="badge priority-badge"
              [ngClass]="getPriorityClass(bug.priority)"
              *ngIf="bug.priority">
              {{ bug.priority }}
            </span>
          </td>
          <td>
            <span
              class="badge status-badge"
              [ngClass]="getStatusClass(bug.status || 'open')">
              {{ bug.status }}
            </span>
          </td>
          <td class="text-black">{{ bug.createdAt | date: "yyyy-MM-dd" }}</td>
          <td>
            <button class="btn btn-view btn-sm" (click)="viewBug(bug)">
              View
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Pagination -->
<div class="d-flex justify-content-center mt-4">
  <div class="pagination pagination-container" *ngIf="totalPages > 1">
    <button
      class="btn btn-light prev-btn"
      [disabled]="pageNumber === 1"
      (click)="changePage(pageNumber - 1)">
      Previous
    </button>

    <button
      *ngFor="let page of [].constructor(totalPages); let i = index"
      class="btn page-link"
      [ngClass]="{
        'btn-primary': pageNumber === i + 1,
        'btn-light': pageNumber !== i + 1,
      }"
      (click)="changePage(i + 1)">
      {{ i + 1 }}
    </button>

    <button
      class="btn btn-light next-btn"
      [disabled]="pageNumber === totalPages"
      (click)="changePage(pageNumber + 1)">
      Next
    </button>
  </div>
</div>

<!-- Modal Popup -->
<div class="modal-overlay" *ngIf="showModal" (click)="closeModal()">
  <div
    class="modal-content"
    (click)="$event.stopPropagation()"
    *ngIf="selectedBug">
    <div class="modal-header border-bottom pb-2">
      <h6 class="m-0 text-black">Bug Details</h6>
      <button class="close-btn" (click)="closeModal()">&times;</button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label><strong>Title:</strong></label>
        <p class="text-black">{{selectedBug.title}}</p>
      </div>
       <div class="form-group">
        <label><strong>App:</strong></label>
        <p class="text-black">{{selectedBug.appName}}</p>
      </div>
      <div class="form-group custom-select-wrapper">
        <label><strong>Priority:</strong></label>
        <p class="text-black">{{selectedBug.priority}}</p>
      </div>
      <div class="form-group">
        <label><strong>Description:</strong></label>
        <p class="text-black">{{selectedBug.description}}</p>
      </div>
      <div class="form-group custom-select-wrapper">
        @if (selectedBug.status !== 'closed') {
          <label><strong>Status:</strong></label>
          <select
            [(ngModel)]="selectedBug.status"
            class="form-control custom-select">
            <option value="open">Open</option>
            <option value="in-progress">In Progress</option>
            <option value="closed">Closed</option>
          </select>
        } @else {
          <label><strong>Status:</strong></label>
          <p class="text-black">{{selectedBug.status}}</p>
        }
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeModal()">Cancel</button>
      <button class="btn btn-primary" (click)="updateBug()">Update Bug</button>
    </div>
  </div>
</div>
